import { createContext, useContext, useEffect } from "react"

import { useFlags } from "./FeatureFlags"

type Theme = "dark" | "light" | "system" | "rebrand"

type ThemeProviderProps = {
  children: React.ReactNode
  storageKey?: string
}

type ThemeProviderState = {
  theme: Theme
  // setTheme: (theme: Theme) => void
}

const initialState: ThemeProviderState = {
  theme: "system",
  // setTheme: () => null,
}

// TODO: uncomment theme toggling code after rebrand is done
const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export function ThemeProvider({
  children,
  // storageKey = "vite-ui-theme",
  ...props
}: ThemeProviderProps) {
  const flags = useFlags()
  const theme: Theme = flags.General.Rebrand ? "rebrand" : "light"

  // const [theme, setTheme] = useState<Theme>(
  //   // () => (localStorage.getItem(storageKey) as Theme) || defaultTheme,
  //   () => defaultTheme,
  // )

  useEffect(() => {
    const root = window.document.documentElement

    root.classList.remove("light", "dark", "rebrand", "font-pelikan")

    // if (theme === "system") {
    //   const systemTheme = window.matchMedia("(prefers-color-scheme: dark)").matches
    //     ? "dark"
    //     : "light"
    //
    //   root.classList.add(systemTheme)
    //   return
    // }

    root.classList.add(theme)
    if (theme === "rebrand") root.classList.add("font-pelikan")
  }, [theme])

  const value = {
    theme,
    // setTheme: (theme: Theme) => {
    //   localStorage.setItem(storageKey, theme)
    //   setTheme(theme)
    // },
  }

  return (
    <ThemeProviderContext.Provider {...props} value={value}>
      {children}
    </ThemeProviderContext.Provider>
  )
}

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined)
    throw new Error("useTheme must be used within a ThemeProvider")

  return context
}
